import BiometricRegistrationFailedModal from '@perpay-web/fintech/components/composite/BiometricRegistrationFailedModal/BiometricRegistrationFailedModal';
import { useBiometricRegistrationFailedModalContext } from '@perpay-web/fintech/hooks/useBiometricRegistrationFailedModalContext';
import { useNativeSelector } from '@perpay-web/native-client/hooks/useNativeSelector';
import { getBiometricsType } from '@perpay-web/native-client/selectors/passkey';

const BiometricRegistrationFailedModalContainer = () => {
    const { setIsAnimatedModalOpen, animatedModalClassName } =
        useBiometricRegistrationFailedModalContext();

    const biometricsType = useNativeSelector(getBiometricsType);

    return (
        <BiometricRegistrationFailedModal
            className={animatedModalClassName}
            onClickClose={() => setIsAnimatedModalOpen(false)}
            biometricsType={biometricsType}
        />
    );
};

export default BiometricRegistrationFailedModalContainer;
